module.exports = __webpack_public_path__ + "static/media/  (9).47468a28.jpg";